// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"41c927cb","186":"e955af60","272":"32e5b614","372":"5ba7bdb9","665":"a421e40d","738":"c3d665a7","841":"0bff5a49","851":"e8b827d5","856":"9c732d38"}[chunkId] + ".chunk.js";
};